if (!customElements.get('slofe-product-links')) {
  customElements.define('slofe-product-links', class extends HTMLElement {
    connectedCallback() {
      this.onClick = (event) => {
        const link = event.target.closest('a[href^="#FreshChapter-"]');
        if (!link) return;
        const target = document.getElementById(link.hash.slice(1));
        if (target instanceof HTMLDetailsElement) target.open = true;
      };
      this.addEventListener('click', this.onClick);
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
    }
  });
}
